<template>
  <div class="transports-form-block" >
    <div
      v-for="(transport, transportIndex) in transports"
      :key="transportIndex"
      :id="visitorTransportFormId(transportIndex)"
    >
      <transport-info-form-block
        v-model="transports[transportIndex]"
        :can-scud="canScud"
        :form="form"
        :errors="errors"
        :transport-index="transportIndex"
        :transport="transport"
        :visitor-index="visitorIndex"
        :visitor="visitor"
        :application-purposes="applicationPurposes"
        :sorted-plate-mask="sortedPlateMask"
        :cfg-menu-transport="cfgMenuTransport"
        :terminal-regions="terminalRegions"
        :transport-types="transportTypes"
        :transport-colors="transportColors"
        :transport-documents="transportDocuments"
        :personal-nationalities="personalNationalities"
        :personal-identifications="personalIdentifications"
        :nationality-documents="nationalityDocuments"
        :document-masks="documentMasks"
        :cfg-menu-visitor="cfgMenuVisitor"
        :typeaheads="typeaheads"
        @remove-transport="removeTransport"
        @disable-submit-button="$emit('disable-submit-button')"
        @enable-submit-button="$emit('enable-submit-button')"
      />
    </div>
    <div :class="addTransportButtonBLockStyles" v-if="showAddTransport">
      <button
        type="button"
        :class="addTransportButtonStyles"
        @click="addTransport()"
      >Добавить транспорт</button>
    </div>
  </div>
</template>

<script>

import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import mainMixin from '@/common/mixins/mainMixin'
import scudMixin from '@/common/mixins/scudMixin'
import { TerminalRegionActions } from '@/common/enums/TerminalRegionActions'
import Transport from '@/common/classes/Transport'
import TransportInfoFormBlock from './TransportInfoFormBlock'
import transportsBlockMixin from '@/common/mixins/application-form/transportsBlockMixin'
import { TransportTypes } from '@/common/enums/TransportTypes'
import VisitorDocumentsFormBlock from '@/common/components/application/form-blocks/visitors/VisitorDocumentsFormBlock.vue'
import VisitorPersonalFormBlock from '@/components/application/form-blocks/visitors/VisitorPersonalFormBlock.vue'

export default {
  name: 'TransportsFormBlock',

  components: {
    VisitorPersonalFormBlock,
    VisitorDocumentsFormBlock,
    TransportInfoFormBlock
  },
  mixins: [
    applicationFormContextMixin,
    applicationFormMixin,
    mainMixin,
    scudMixin,
    transportsBlockMixin
  ],

  model: {
    prop: 'transports',
    event: 'change-transports'
  },

  props: {
    cfgMenuTransport: {
      type: [Object, Array],
      default: () => []
    },

    personalNationalities: {
      type: Array,
      default: () => []
    },

    personalIdentifications: {
      type: Array,
      default: () => []
    },

    nationalityDocuments: {
      type: Array,
      default: () => []
    },

    documentMasks: {
      type: Array,
      default: () => []
    },

    cfgMenuVisitor: {
      type: [Object, Array],
      default: () => []
    },

    typeaheads: {
      type: Object,
      default: () => ({})
    },

    sortedPlateMask: {
      type: Object
    },

    transportColors: {
      type: Array,
      default: () => [],
      required: true
    },

    transportDocuments: {
      type: [Object, Array],
      default: () => []
    },

    transportTypes: {
      type: Array,
      default: () => {}
    },
    applicationPurposes: {
      type: [Array, Object],
      default: () => []
    },
    transports: {
      type: Array,
      required: true
    },

    visitor: {
      type: Object,
      default: () => ({})
    },

    visitorIndex: {
      type: Number,
      required: true
    }
  },

  computed: {
    canAddTransport() {
      let maxTransportsCount = Number(this.configuration.form_transport)
      let currentTransportsCount = this.transports.length
      return currentTransportsCount < maxTransportsCount
    },

    showAddTransport() {
      const transportConditions = TerminalRegionActions.transportConditions
      let transportAccess = this.terminalRegion?.transport_access

      return !this.isView && transportConditions[transportAccess] && this.canAddTransport && !this.isPassKindPedestrian
    },

    applicationPurpose() {
      return this.applicationPurposes[this.form.application.application_group_purpose_id]
    },

    addTransportButtonStyles() {
      if (this.isPassKindTransport) {
        return ['btn', 'btn-primary', 'btn-primary-blue'];
      }

      return ['btn', 'btn-default', 'btn-primary-white']
    },

    addTransportButtonBLockStyles() {
      if (this.isPassKindTransport) {
        return ['text-center', 'transport-button-block'];
      }

      return ['text-center']
    }
  },

  async created () {
    if (this.isDuplicate || this.isDraft) {
      for (let transport of this.transports) {
        if (transport.type && transport.type === TransportTypes.Pedestrian) {
          this.removeTransport(transport)
        }
      }
    }
  },

  methods: {
    addTransport () {
      let type = 'auto'
      if (this.transports[this.transports.length - 1]) {
        type = this.transports[this.transports.length - 1].type
      }

      let errorType = false
      if (this.form.visitors[0].transports[0] && type === 'truck') {
        errorType = this.form.visitors[0].transports[0].type !== 'truck'
      }

      this.transports.push(new Transport({ type, errorType }))
      // this.scrollToLastTransport()
    },

    removeTransport (transportIndex) {
      this.transports.splice(transportIndex, 1)
      // this.scrollToLastTransport()
    },

    scrollToLastTransport () {
      if (this.transports.length === 0) {
        return
      }

      this.$nextTick(() => {
        this.$scrollTo('#' + this.visitorTransportFormId(this.transports.length - 1), 100, {
          offset: -90
        })
      })
    },

    visitorTransportFormId (transportIndex) {
      return `transport-${this.visitorIndex}-${transportIndex}`
    }
  }
}
</script>
